import { constants } from "@/constants";
import { routes } from "@/router";
import { useTranslation } from "react-i18next";
import { HiArrowRight } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";

import Button from "@/components/atoms/Button";
import FeaturedText from "@/components/molecules/FeaturedText";

type Props = {
  isEnterprise: boolean;
};

const SearchLimitReached = ({ isEnterprise }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={"sticky left-0 flex h-48 shrink-0 items-center justify-center px-6 py-4"}>
      {isEnterprise ? (
        <FeaturedText heading={t("search.limit.reached.title")} body={t("search.limit.reached.text")} size={"lg"}>
          <a
            href={`mailto:${constants.supportMail}`}
            className={"text-xs text-brand-primary hover:text-brand-primary-hover"}
          >
            {constants.supportMail}
          </a>
        </FeaturedText>
      ) : (
        <FeaturedText heading={t("search.limit.upgrade.title")} body={t("search.limit.upgrade.text")} size={"lg"}>
          <div className={"mt-2"}>
            <Button
              label={t("settings.plans.options.upgrade")}
              onClick={() => navigate(routes.plans)}
              size={"xs"}
              trailingIcon={<HiArrowRight className={"size-4"} />}
            />
          </div>
        </FeaturedText>
      )}
    </div>
  );
};

export default SearchLimitReached;
